// extracted by mini-css-extract-plugin
export default {"BaseSettingsPage":"archive-page-module__BaseSettingsPage--WUAZp"};